<scitis-app-global-page-header [pageTitle]="'Status indicator'">
</scitis-app-global-page-header>

<form>
  <fieldset [disabled]="!userRole.isSuperAdminRole && !userRole.isTechAdminRole">
    <div class="row mb-3">
      <div class="col-lg-6 col-xs-6">
        <div class="form-group">
          <label translate>Pre-Time</label>
          <div class="input-group">
            <input [(ngModel)]="machine.chartConfig.statusIndicator.preTime" class="form-control" name="preTime"
              type="number">
              <div class="input-group-append">
                <span class="input-group-text" translate>Sec.</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xs-6">
          <div class="form-group">
            <label translate>Post-Time</label>
            <div class="input-group">
              <input [(ngModel)]="machine.chartConfig.statusIndicator.postTime" class="form-control" name="postTime"
                type="number">
                <div class="input-group-append">
                  <span class="input-group-text" translate>Sec.</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <table class="table vertical-align-middle table-striped vertical-align-middle">
          <thead>
            <tr>
              <th style="width: 23%;" translate>Correlation</th>
              <th style="width: 23%;" translate>Signal</th>
              <th style="width: 23%;" translate>Operator</th>
              <th style="width: 23%;" translate>Value</th>
              <th></th>
            </tr>
          </thead>
          <tbody>

            @for (expr of machine.chartConfig.statusIndicator.expressions; track expr) {
              <tr>
                <td [innerText]="expr.correlation"></td>
                <td [innerText]="expr.signalLabel | translate"></td>
                <td [innerText]="getShownOperator(expr.operator)"></td>
                <td [innerText]="expr.value"></td>
                <td class="text-right">
                  <div aria-label="..." class="btn-group" role="group">
                    <button (click)="onRemoveExpression(expr)"
                      [disabled]="!(userRole.isTechAdminRole || userRole.isSuperAdminRole)"
                      [title]="'Delete expression' | translate"
                      class="btn btn-sm btn-outline-danger"
                      type="button">
                      <span class="fa-solid fa-trash"></span>
                    </button>
                  </div>
                </td>
              </tr>
            }
            <tr>
              <td>
                <div class="form-group mb-0">
                  <ng-select [(ngModel)]="selectedCorrelation"
                    [disabled]="!(userRole.isTechAdminRole || userRole.isSuperAdminRole)"
                    id="correlation"
                    [items]="possibleCorrelations"
                  name="correlation"></ng-select>
                </div>
              </td>
              <td>
                <!--signal input-->
                <div class="form-group mb-0">
                  <ng-select [(ngModel)]="selectedSignal"
                    [items]="signalsArray"
                    [disabled]="!(userRole.isTechAdminRole || userRole.isSuperAdminRole)"
                    id="signal"
                    name="signal">
                    <ng-template ng-label-tmp let-item="item">
                      <span [innerText]="item.label | translate"></span>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      <div class="dropdown-tooltip-hover-machine-conf-signal" [title]="item.label | translate" [innerText]="item.label | translate"></div>
                      <small [innerText]="item.name"></small>
                    </ng-template>
                  </ng-select>
                </div>
              </td>
              <td>
                <div class="form-group mb-0">
                  <ng-select [(ngModel)]="selectedOperator"
                    [items]="operators"
                    [disabled]="!(userRole.isTechAdminRole || userRole.isSuperAdminRole)"
                    id="operator"
                  name="operator"></ng-select>
                </div>
              </td>
              <td>
                <div class="form-group mb-0">
                  <input [(ngModel)]="expressionValue"
                    [disabled]="!(userRole.isTechAdminRole || userRole.isSuperAdminRole)"
                    class="form-control"
                    id="expressionValue"
                    name="value" type="text">
                  </div>
                </td>
                <td class="text-right">
                  <div aria-label="..." class="btn-group" role="group">
                    <button (click)="onAddExpression()"
                      [disabled]="(selectedCorrelation==='') || (!selectedSignal) || (selectedOperator==='') || !(userRole.isTechAdminRole || userRole.isSuperAdminRole)"
                      [title]="'Add expression' | translate"
                      class="btn btn-sm btn-primary"
                      type="button">
                      <span class="fa-solid fa-plus"></span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </fieldset>
      </form>
      <div class="divider"></div>

      @if (showSaveButton()) {
        <button (click)="onSaveStatusIndicator()"
          class="btn btn-primary btn-lg btn-save" translate>Save
        </button>
      }
